import { render, staticRenderFns } from "./popular_key_words.vue?vue&type=template&id=53e8cd7c&"
import script from "./popular_key_words.vue?vue&type=script&lang=js&"
export * from "./popular_key_words.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports